export enum AccessItem {
  DASHBOARD = 'DASHBOARD',
  CLIENTS = 'CLIENT',
  REPORT = 'REPORTS',
  USERS = 'USERS',
  ROLES = 'ROLES',
  SETTINGS = 'SETTINGS'
}
